import PageCard from "PFComponents/page/page_card";
import React from "react";

import css from "./imports_history_page.module.scss";
import { ImportsHistoryTable } from "./parts";

export const ImportHistoryPage = (): JSX.Element => (
  <PageCard variant="spaced" classes={{ card: css.pageCardInner, wrap: css.pageCardOuter }}>
    <ImportsHistoryTable />
  </PageCard>
);
